<!--
  预约办卡
  lovi 2020-06-23
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="$t('wallet.reservationHandleCard')"
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    />
    <div class="scroll-wrapper">
      <van-cell-group>
        <van-cell :title="$t('wallet.telephoneReservation')">
          <span slot="default" @click="_telephone(data.service_phone)">
            {{ data.service_phone }}
          </span>
        </van-cell>
        <van-cell :value="data.service_wechat">
          <div slot="title">
            <span>{{ $t("wallet.weChatReservation") }}</span>
            <i
              class="icon-copy"
              :data-clipboard-text="data.service_wechat"
              @click="copyText"
            ></i>
          </div>
        </van-cell>
      </van-cell-group>
      <div class="button-wrap">
        <van-button
          round
          type="primary"
          block
          @click="_telephone(data.service_phone)"
        >
          {{ $t("wallet.quickReservation") }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
export default {
  props: {
    data: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      // 返回事件
      this.$emit("update:datailFlag", false);
    },
    copyText() {
      var clipboard = new Clipboard(".icon-copy");
      clipboard.on("success", e => {
        console.info("Action:", e.action);
        this.$toast(this.$t("common.copySuccess"));
        clipboard.destroy(); // 释放内存
      });
      clipboard.on("error", e => {
        console.info("error:", e.action);
        this.$toast(this.$t("common.browserNoCopy"));
        clipboard.destroy(); // 释放内存
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
/deep/.van-cell {
  .van-cell__title {
    flex: initial;
    margin-right: 10px;
    div {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .icon-copy {
        margin-left: 10px;
        width: 10px;
        height: 12px;
        background: url("~@/assets/images/public/icon_copy@2x.png") no-repeat;
        background-size: 100%;
      }
    }
  }
}
</style>
